import { Group } from "@mantine/core";
import { useAtom } from "jotai";
import { type ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { spacing } from "#app/theme/v2/spacing";
import { Button } from "#components/atoms/Button/Button";
import { IconButton } from "#components/atoms/IconButton/IconButton";
import { Tooltip } from "#components/atoms/Tooltip/Tooltip";
import { navbarCollapsedAtom } from "#components/templates/Navbar/navbarAtom";
import { Icon } from "#shared/icons/Icon";

type PageHeaderProps = {
  actionLeftSection?: ReactNode;
  actionRightSection?: ReactNode;
};

export const PageHeader = ({ actionLeftSection, actionRightSection }: PageHeaderProps) => {
  const { t } = useTranslation("components");
  const [isCollapsed, setNavbarCollapsed] = useAtom(navbarCollapsedAtom);
  const tooltipLabel = isCollapsed ? t("pageHeader.expand") : t("pageHeader.collapse");

  return (
    <Group justify="space-between" px={spacing[3]} pt={spacing[3]} pb={spacing[4]}>
      <Tooltip label={tooltipLabel}>
        <IconButton
          variant="transparent"
          size="sm"
          aria-label="toggle sidebar"
          onClick={() => setNavbarCollapsed((v) => !v)}
        >
          <Icon name="panelLeft" size={16} />
        </IconButton>
      </Tooltip>
      <Group gap={spacing[2]}>
        {actionLeftSection}
        <Button variant="tertiary" size="sm" disabled>
          {t("pageHeader.needHelp")}
        </Button>
        {actionRightSection}
      </Group>
    </Group>
  );
};
